











import BuildThumbnail from './scripts';
export default BuildThumbnail;
